import { useEffect, useState } from 'react';

/**
 * ⌥1–⌥9 hints (eddy, 2026-10-26: "each tab needs to show 1–9 when we hold
 * down the option button", like the ⌥B on Build). The bar carries
 * `group/topbar` and `data-option-held` while Option is down; each chip and tab
 * renders its key hidden until then, so nothing moves in the bar otherwise.
 */
export function SlotKey({ n }: { n: number | undefined }) {
  if (!n || n > 9) return null;
  return (
    <span
      data-testid="slot-key"
      aria-hidden
      className="hidden shrink-0 items-center rounded-[6px] border border-border bg-[var(--bg-3)] px-[5px] py-px font-mono text-[11px] leading-tight font-medium text-[var(--ink-1)] group-data-[option-held=true]/topbar:inline-flex"
    >
      ⌥{n}
    </span>
  );
}

/** True while the Option / Alt key is held down (and the tab has focus). */
export function useOptionHeld(): boolean {
  const [held, setHeld] = useState(false);
  useEffect(() => {
    const down = (e: KeyboardEvent) => setHeld(e.key === 'Alt' || (e.altKey && !e.metaKey && !e.ctrlKey));
    const up = (e: KeyboardEvent) => {
      if (e.key === 'Alt' || !e.altKey) setHeld(false);
    };
    const reset = () => setHeld(false);
    window.addEventListener('keydown', down);
    window.addEventListener('keyup', up);
    window.addEventListener('blur', reset);
    return () => {
      window.removeEventListener('keydown', down);
      window.removeEventListener('keyup', up);
      window.removeEventListener('blur', reset);
    };
  }, []);
  return held;
}
